import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { StatusItem } from "@ServerTypes/status/status.schema";

type ProjectStatusMap = Record<string, StatusItem>;

const initialProjectsStatusesState: ProjectStatusMap = {};

const projectsStatusesSlice = createSlice({
  name: "projectsStatuses",
  initialState: initialProjectsStatusesState,
  reducers: {
    setProjectsStatusesData: (_state: ProjectStatusMap, action: PayloadAction<StatusItem[]>) =>
      action.payload.reduce(
        (prev: ProjectStatusMap, curr: StatusItem) => ({ ...prev, [curr.id ?? curr._id ?? ""]: curr }),
        {},
      ),
  },
});

export const { setProjectsStatusesData } = projectsStatusesSlice.actions;

export const projectsStatuses = projectsStatusesSlice.reducer;

export default projectsStatusesSlice.reducer;
